import { responseOne } from "./tatResponseT1";
import { responseTwo } from "./tatResponseT2";
import { responseThree } from "./tatResponseT3";
import { responseFour } from "./tatResponseT4";
import { responseFive } from "./tatResponseT5";
import { responseSix } from "./tatResponseT6";
import { responseSeven } from "./tatResponseT7";
import { responseEight } from "./tatResponseT8";
import { responseNine } from "./tatResponseT9";
import { responseTen } from "./tatResponseT10";

export const responses = {
  one: responseOne,
  two: responseTwo,
  three: responseThree,
  four: responseFour,
  five: responseFive,
  six: responseSix,
  seven: responseSeven,
  eight: responseEight,
  nine: responseNine,
  ten: responseTen,
};
